module.exports = __webpack_public_path__ + "img/fashionbug.f944e04b.png";